/**
 * Globaler Error Handler für API-Anfragen
 */

/**
 * Behandle API-Fehler und gebe benutzerfreundliche Nachrichten zurück
 * @param {Error} error - Axios Error Objekt
 * @param {string} defaultMessage - Fallback-Nachricht
 * @returns {string} - Benutzerfreundliche Fehlernachricht
 */
export const handleApiError = (error, defaultMessage = 'Ein Fehler ist aufgetreten') => {
  if (!error.response) {
    // Netzwerkfehler oder Server nicht erreichbar
    return 'Server nicht erreichbar. Bitte prüfen Sie Ihre Internetverbindung.';
  }

  const { status, data } = error.response;

  // HTTP Status basierte Fehlerbehandlung
  switch (status) {
    case 400:
      return data?.detail || 'Ungültige Anfrage. Bitte überprüfen Sie Ihre Eingaben.';

    case 401:
      return 'Nicht authentifiziert. Bitte melden Sie sich erneut an.';

    case 403:
      return data?.detail || 'Keine Berechtigung für diese Aktion.';

    case 404:
      return data?.detail || 'Ressource nicht gefunden.';

    case 409:
      return data?.detail || 'Konflikt: Die Ressource existiert bereits.';

    case 422:
      // Validierungsfehler von Pydantic
      if (data?.detail && Array.isArray(data.detail)) {
        const errors = data.detail.map(err =>
          `${err.loc.join(' > ')}: ${err.msg}`
        ).join(', ');
        return `Validierungsfehler: ${errors}`;
      }
      return data?.detail || 'Validierungsfehler. Bitte überprüfen Sie Ihre Eingaben.';

    case 429:
      return data?.detail || 'Zu viele Anfragen. Bitte versuchen Sie es später erneut.';

    case 500:
      return 'Serverfehler. Bitte kontaktieren Sie den Administrator.';

    case 503:
      return 'Service vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut.';

    default:
      return data?.detail || defaultMessage;
  }
};

/**
 * Log Fehler zur Konsole (in Production können diese an einen Service gesendet werden)
 * @param {Error} error - Fehler-Objekt
 * @param {string} context - Kontext des Fehlers
 */
export const logError = (error, context = '') => {
  console.error(`[Error${context ? ` - ${context}` : ''}]:`, error);

  if (error.response) {
    console.error('Response Status:', error.response.status);
    console.error('Response Data:', error.response.data);
  }
};

/**
 * Zeige Toast-Benachrichtigung für Fehler
 * (Optional: Kann mit einer Toast-Library wie react-toastify erweitert werden)
 * @param {string} message - Fehlernachricht
 */
export const showErrorToast = (message) => {
  // Einfache Browser-Alert für jetzt
  // TODO: Integration mit Toast-Library
  console.error('Error Toast:', message);
  // alert(message); // Optional: Auskommentiert für bessere UX
};

/**
 * Behandle Authentifizierungsfehler und leite zum Login weiter
 * @param {Error} error - Fehler-Objekt
 * @param {function} navigate - React Router navigate-Funktion
 */
export const handleAuthError = (error, navigate) => {
  if (error.response?.status === 401) {
    navigate('/admin');
    return true;
  }
  return false;
};
